import { useContext } from "react";
import { GalleryPreviewContext, GalleryPreviewContextType } from "./context";
import { Check, ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent } from "../ui/dialog.tsx";
import { Button } from "../ui/button.tsx";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";

type Props = {
  selectedImage: number | undefined
  onSelect: (image: number) => void
}

const ImagePreview = ({ selectedImage, onSelect }: Props) => {

  const { currentImageIndex, setOpenPreview, openPreview, nextImage, prevImage } = useContext<GalleryPreviewContextType>(GalleryPreviewContext)

  const theme = useAtomValue(themeAtom)

  return (
    <Dialog open={openPreview} onOpenChange={() => setOpenPreview(false)} modal>
      <DialogContent className="w-[75vw] lg:w-[50vw] aspect-square max-w-full rounded-md bg-white p-0 outline-none border-0">

        <Button size="icon" className="fixed top-[50%]  hover:text-white -left-5 xl:-left-10 z-50 bg-white rounded-full text-black cursor-pointer" onClick={prevImage}><ChevronLeft /></Button>
        <Button size="icon" className="fixed top-[50%] hover:text-white -right-5 xl:-right-10 z-50 bg-white rounded-full text-black cursor-pointer" onClick={nextImage}><ChevronRight /></Button>
        <div className="relative flex items-center justify-center">
          <button
            onClick={() => onSelect(currentImageIndex!.id)}
            style={{
              backgroundImage: selectedImage === currentImageIndex!.id ? `linear-gradient(45deg, ${theme.secondary}, ${theme.alternate})` : "linear-gradient(45deg, #fff, #fff)",
              backgroundSize: "200%",
              color: selectedImage === currentImageIndex!.id ? "white" : "black"
            }}
            className="absolute animate-wave top-4 left-4 p-2 z-50 rounded-full transition-colors"
          >
            <Check size={24} />
          </button>
          <div className="relative w-full h-full overflow-hidden">
            <img
              src={currentImageIndex?.url}
              className="size-full object-contain rounded-lg"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ImagePreview;
